import { useState } from "react";
import {
    Anchor,
    Box,
    Button,
    Center,
    Divider,
    Grid,
    Group,
    Image,
    Paper,
    PasswordInput,
    Stack,
    Text,
    TextInput,
    Title, Modal, ThemeIcon
} from "@mantine/core";
import { useMediaQuery } from '@mantine/hooks';

import {
    IconMail,
    IconPhone,
    IconScale,
    IconShieldLock,
    IconUser, IconLock,
} from "@tabler/icons-react";
import CdrLogo from "../../Newlogo/image.png";
import LawBg from "../../Newlogo/image.png";
import { message } from "antd";
import { Userauthcontexthooks } from "../../Hooks/Userauthcontexthooks";
import { useDisclosure } from '@mantine/hooks';
import { Adminauthcontexthooks } from "../../Hooks/Adminauthcontexthooks";

export default function PremiumLogin() {
    const { dispatch } = Userauthcontexthooks();
    const { adispatch } = Adminauthcontexthooks();
    const [authMode, setAuthMode] = useState("login");
    const isMobile = useMediaQuery('(max-width: 768px)');
    const [loading, setloading] = useState(false);
    const [inputs, setInputs] = useState({
        name: '',
        email: '',
        phone: '',
        password: '',
    })
    const [opened, { open, close }] = useDisclosure(false);
    const [Admininputs, setadmininputs] = useState({
        adminemail: '',
        adminpassword: '',
    })
    const Adminonchange = (e) => {
        const { name, value } = e.target;
        setadmininputs({ ...Admininputs, [name]: value });
    }
    const handleChange = (e) => {
        const { name, value } = e.target;
        setInputs({ ...inputs, [name]: value })
    }
    const [forgotOpened, setForgotOpened] = useState(false);
    //const [openedforgot, { forgotOpen, forgotClose }] = useDisclosure(false);

    const [forgotInputs, setForgotInputs] = useState({
        email: "",
        mobile: "",
        password: "",
        confirmpassword: "",
    });

    const ForgotOnChange = (e) => {
        const { name, value } = e.target;

        setForgotInputs((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const saveToken = (token) => {
        //const decodedToken = jwtDecode(token); // Use jwt-decode library
        //const expiryTime = decodedToken.exp * 1000; // Convert expiry time to milliseconds
        localStorage.setItem('user', token);
        //localStorage.setItem('expiryTime', expiryTime);
    };

    const handleSubmit = async () => {
        setloading(true);
        if (authMode === 'signup') {
            const { name, email, phone, password } = inputs;

            if (name === '') {
                message.error("Please enter your Name");
                return;
            }
            if (email === '') {
                message.error("Please enter your Email");
                return;
            }
            if (phone === '') {
                message.error("Please enter your Mobile Number");
                return;
            }
            if (phone.length !== 10 || !/^\d+$/.test(phone)) {
                message.error("Please enter valid 10 digit Mobile Number");
                return;
            }
            if (password === '') {
                message.error("Please create the password");
                return;
            }

            try {
                const res = await fetch('https://cdr-backend.onrender.com/add/new-user/mobile', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({ name, email, phone, password })
                });
                // const Result = await res.json();
                if (res.status === 201) {
                    // message.loading("Please wait, we re-direct you, with in 5 seconds.", 2);
                    message.success("Your account successfully created.");
                    setAuthMode('login');
                    // save the Token in Local Storage.
                    // saveToken(Result.token);
                    //localStorage.setItem('user', JSON.stringify(Result.token));
                    // Update Auth Context
                    //dispatch({ type: 'LOGIN', payload: Result.token });
                    // setTimeout(() => {
                    //     window.location.href = "/home"
                    // }, 2000);
                    return;
                } else if (res.status === 200) {
                    message.success("Old account upgraded successfully");
                    setAuthMode('login');
                    return;
                }
                else if (res.status === 400) {
                    message.error("User Already Exist, Please Login");
                    return;
                }
                else {
                    message.error("Something Went Wrong");
                    return;
                }
            } catch (error) {
                message.error("Failed to connect to the server. Please try again later.");
                console.error("Authentication error:", error.message);
            }
            finally {
                setloading(false);
            }
        } else if (authMode === 'login') {
            const { phone, password } = inputs;
            if (phone === '') {
                message.error("Please enter your Mobile Number");
                return;
            }
            if (phone.length !== 10 || !/^\d+$/.test(phone)) {
                message.error("Please enter valid 10 digit Mobile Number");
                return;
            }
            if (password === '') {
                message.error("Please enter the password");
                return;
            }

            const res = await fetch('https://cdr-backend.onrender.com/login/existing-user/mobile', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ phone, password })
            });
            const Result = await res.json();
            if (res.status === 200) {
                // message.loading("Please wait, we re-direct you, with in 5 seconds.", 5);
                message.success("Login Successfully.");
                // save the Token in Local Storage.
                saveToken(Result.token);
                //getAndSendToken(Result.VerifyUser._id); // Get and send FCM token
                //localStorage.setItem('user', JSON.stringify(Result.token));
                // Update Auth Context
                dispatch({ type: 'LOGIN', payload: Result.token });
                // setTimeout(() => {
                //     window.location.href = "/v2/home"
                // }, 2000);
                setloading(false);
                return;
            } else if (res.status === 403) {
                message.error("Your account is old. Please create a password to continue.")
                setAuthMode('signup');
                setloading(false);
                return;
            }

            else if (res.status === 401) {
                message.error("Invalid User");
                setloading(false);
                return;
            } else {
                message.error("Something Went Wrong");
                setloading(false);
                return;
            }
        }
    }
    const Admin_Login = async () => {
        const { adminemail, adminpassword } = Admininputs
        if (!adminemail || !adminpassword) {
            message.error('All fileds are required');
            return
        }

        const res = await fetch('https://cdr-backend.onrender.com/admin/login', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ adminemail, adminpassword })
        });
        if (res.status === 200) {
            const data = await res.json();
            message.loading('Please wait, we trying to connect you with our server');
            message.success('Logged In');
            close();
            sessionStorage.setItem('user', data.token)
            // Update Auth Context
            adispatch({ type: 'LOGIN', payload: data.token });
            setTimeout(() => {
                window.location.href = "/cdr/admin"
            }, 2000);
            return
        } else {
            message.error('Invalid credentials');
            return
        }
    }
    const ForgotPassword = async () => {

        const {
            email,
            mobile,
            password,
            confirmpassword
        } = forgotInputs;

        if (
            !email ||
            !mobile ||
            !password ||
            !confirmpassword
        ) {
            return message.error("Please fill all fields");
        }

        if (password !== confirmpassword) {
            return message.error(
                "Passwords do not match"
            );
        }

        const res = await fetch(
            "https://cdr-backend.onrender.com/v2/forgot-password",
            {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    email,
                    mobile,
                    password,
                }),
            }
        );

        const data = await res.json();

        if (res.status === 200) {
            message.success(data.message);
            setForgotOpened(false);

            setForgotInputs({
                email: "",
                mobile: "",
                password: "",
                confirmpassword: "",
            });
        } else {
            message.error(data.message);
        }
    };
    const OpenForgotModal = () => { // for forgot modal open
        //setSelectedLegalUpdate(item);
        setForgotOpened(true);
    };

    return (
        <Box
            style={{
                minHeight: "100vh",
                background:
                    "linear-gradient(135deg, #020617 0%, #0f172a 40%, #111827 100%)",
                overflow: "hidden",
                position: "relative",
            }}
        >
            {/* Background Glow */}
            <Box
                style={{
                    position: "absolute",
                    width: 500,
                    height: 500,
                    borderRadius: "50%",
                    background: "rgba(59,130,246,0.18)",
                    filter: "blur(120px)",
                    top: -100,
                    right: -100,
                }}
            />

            <Box
                style={{
                    position: "absolute",
                    width: 400,
                    height: 400,
                    borderRadius: "50%",
                    background: "rgba(6,182,212,0.15)",
                    filter: "blur(120px)",
                    bottom: -100,
                    left: -100,
                }}
            />
            <Modal // Admin Login Modal
                opened={opened}
                onClose={close}
                centered
                withCloseButton={false}
                overlayProps={{
                    blur: 8,
                    backgroundOpacity: 0.65,
                }}
                radius="30px"
                size="md"
                padding={0}
                styles={{
                    content: {
                        background:
                            "linear-gradient(135deg,#0f172a 0%,#111827 45%,#1e293b 100%)",
                        border: "1px solid rgba(255,255,255,0.08)",
                        overflow: "hidden",
                    },
                    body: {
                        padding: 0,
                    },
                }}
            >

                {/* TOP GLOW */}
                <Box
                    style={{
                        position: "absolute",
                        width: 250,
                        height: 250,
                        borderRadius: "50%",
                        background: "rgba(59,130,246,0.25)",
                        filter: "blur(90px)",
                        top: -80,
                        right: -80,
                        zIndex: 0,
                    }}
                />

                <Box
                    p="xl"
                    style={{
                        position: "relative",
                        zIndex: 2,
                    }}
                >

                    {/* HEADER */}
                    <Center mb="lg">

                        <Stack align="center" gap={5}>

                            <ThemeIcon
                                size={70}
                                radius="100%"
                                variant="gradient"
                                gradient={{ from: "blue", to: "cyan" }}
                            >
                                <IconShieldLock size={34} />
                            </ThemeIcon>

                            <Title
                                order={2}
                                c="white"
                                ta="center"
                            >
                                Admin Portal
                            </Title>

                            <Text
                                size="sm"
                                c="#94a3b8"
                                ta="center"
                            >
                                Secure access for authorized administrators only
                            </Text>

                        </Stack>

                    </Center>

                    {/* ALERT */}
                    {/* <Alert
                        radius="xl"
                        variant="light"
                        color="red"
                        icon={<IconAlertTriangle size={18} />}
                        mb="lg"
                        styles={{
                            root: {
                                background: "rgba(239,68,68,0.12)",
                                border: "1px solid rgba(239,68,68,0.18)",
                            },
                            message: {
                                color: "#fecaca",
                                fontSize: 13,
                                lineHeight: 1.6,
                            },
                        }}
                    >
                        Unauthorized login attempts may lead to permanent suspension
                        by GV InfoTech security systems.
                    </Alert> */}

                    {/* INPUTS */}
                    <Stack gap="md">

                        <TextInput
                            label={
                                <Text c="#cbd5e1" fw={500}>
                                    Registered Email
                                </Text>
                            }
                            placeholder="admin@gvinfotech.com"
                            radius="xl"
                            size="md"
                            leftSection={<IconMail size={18} />}
                            name="adminemail"
                            value={Admininputs.adminemail}
                            onChange={Adminonchange}
                            styles={{
                                input: {
                                    background: "rgba(255,255,255,0.05)",
                                    border: "1px solid rgba(255,255,255,0.08)",
                                    color: "white",
                                    height: 52,
                                },
                            }}
                        />

                        <PasswordInput
                            label={
                                <Text c="#cbd5e1" fw={500}>
                                    Password
                                </Text>
                            }
                            placeholder="Enter secure password"
                            radius="xl"
                            size="md"
                            leftSection={<IconLock size={18} />}
                            name="adminpassword"
                            value={Admininputs.adminpassword}
                            onChange={Adminonchange}
                            styles={{
                                input: {
                                    background: "rgba(255,255,255,0.05)",
                                    border: "1px solid rgba(255,255,255,0.08)",
                                    color: "white",
                                    height: 52,
                                },
                            }}
                        />

                    </Stack>

                    {/* LOGIN BUTTON */}
                    <Button
                        fullWidth
                        size="lg"
                        radius="xl"
                        mt="xl"
                        variant="gradient"
                        gradient={{ from: "blue", to: "cyan" }}
                        onClick={Admin_Login}
                        styles={{
                            root: {
                                height: 54,
                                fontSize: 16,
                                fontWeight: 700,
                                boxShadow: "0 10px 30px rgba(59,130,246,0.35)",
                            },
                        }}
                    >
                        Secure Login
                    </Button>

                    {/* FOOTER */}
                    <Center mt="lg">

                        <Text
                            size="xs"
                            c="#64748b"
                        >
                            GV InfoTech • Secure Administrative Access
                        </Text>

                    </Center>

                </Box>

            </Modal>

            <Modal // Forgot Password Modal
                opened={forgotOpened}
                onClose={() => setForgotOpened(false)}
                centered
                size="md"
                radius="xl"
                title={
                    <Group gap="xs">
                        🔐
                        <Text fw={700}>Reset Password</Text>
                    </Group>
                }
            >
                <Paper
                    p="md"
                    radius="xl"
                    style={{
                        background: "rgba(96,165,250,0.08)",
                        border: "1px solid rgba(96,165,250,0.15)",
                    }}
                >
                    <Text size="sm" c="dimmed">
                        Verify your registered Email ID and Mobile Number to create a new password.
                    </Text>
                </Paper>

                <TextInput
                    mt="md"
                    label="Registered Email"
                    placeholder="example@gmail.com"
                    radius="xl"
                    name="email"
                    value={forgotInputs.email}
                    onChange={ForgotOnChange}
                    leftSection="📧"
                />

                <TextInput
                    mt="md"
                    label="Registered Mobile Number"
                    placeholder="9876543210"
                    radius="xl"
                    name="mobile"
                    value={forgotInputs.mobile}
                    onChange={ForgotOnChange}
                    leftSection="📱"
                />

                <PasswordInput
                    mt="md"
                    label="New Password"
                    placeholder="Enter new password"
                    radius="xl"
                    name="password"
                    value={forgotInputs.password}
                    onChange={ForgotOnChange}
                />

                <PasswordInput
                    mt="md"
                    label="Confirm Password"
                    placeholder="Confirm new password"
                    radius="xl"
                    name="confirmpassword"
                    value={forgotInputs.confirmpassword}
                    onChange={ForgotOnChange}
                />

                <Button
                    fullWidth
                    mt="xl"
                    radius="xl"
                    size="md"
                    variant="gradient"
                    gradient={{ from: "blue", to: "cyan" }}
                    onClick={ForgotPassword}
                >
                    Reset Password
                </Button>
            </Modal>

            <Grid gutter={0} style={{ minHeight: "100vh" }}>
                {/* LEFT SIDE */}
                <Grid.Col
                    span={{ base: 12, md: 6 }}
                    visibleFrom="md"
                    style={{
                        position: "relative",
                        overflow: "hidden",
                    }}
                >
                    {/* Background */}
                    <Box
                        style={{
                            position: "absolute",
                            inset: 0,
                            backgroundImage: `url(${LawBg})`,
                            backgroundSize: "cover",
                            backgroundPosition: "center",
                            opacity: 0.18,
                        }}
                    />

                    {/* Dark Overlay */}
                    <Box
                        style={{
                            position: "absolute",
                            inset: 0,
                            background:
                                "linear-gradient(180deg, rgba(2,6,23,0.4), rgba(2,6,23,0.95))",
                        }}
                    />

                    {/* Content */}
                    <Center
                        style={{
                            position: "relative",
                            zIndex: 2,
                            height: "100%",
                            padding: 40,
                        }}
                    >
                        <Stack align="center" gap="xl">
                            {/* Logo */}
                            <Paper
                                radius="100%"
                                p={18}
                                style={{
                                    background: "rgba(255,255,255,0.08)",
                                    backdropFilter: "blur(20px)",
                                    border: "1px solid rgba(255,255,255,0.12)",
                                    boxShadow: "0 0 40px rgba(59,130,246,0.4)",
                                }}
                            >
                                <Image
                                    src={CdrLogo}
                                    w={170}
                                    h={170}
                                    fit="contain"
                                    radius="100%"
                                />
                            </Paper>

                            {/* Main Heading */}
                            <Stack align="center" gap={10}>
                                <Title
                                    order={1}
                                    ta="center"
                                    style={{
                                        color: "white",
                                        fontSize: "58px",
                                        fontWeight: 900,
                                        lineHeight: 1.1,
                                        letterSpacing: -2,
                                    }}
                                >
                                    Court Date
                                    <br />
                                    Reminder
                                </Title>

                                <Text
                                    ta="center"
                                    size="lg"
                                    style={{
                                        color: "#cbd5e1",
                                        maxWidth: 520,
                                        lineHeight: 1.9,
                                        fontSize: 18,
                                    }}
                                >
                                    Professional legal management platform for Lawyers,
                                    Clients, Judges and Court Staff.
                                </Text>
                            </Stack>

                            {/* Feature Cards */}
                            <Group mt="lg">
                                <Paper
                                    radius="xl"
                                    p="md"
                                    style={{
                                        background: "rgba(255,255,255,0.08)",
                                        border: "1px solid rgba(255,255,255,0.08)",
                                        backdropFilter: "blur(10px)",
                                    }}
                                >
                                    <Group gap="xs">
                                        <IconScale size={20} color="#60a5fa" />
                                        <Text c="white" fw={600}>
                                            Smart Court Alerts
                                        </Text>
                                    </Group>
                                </Paper>

                                <Paper
                                    radius="xl"
                                    p="md"
                                    style={{
                                        background: "rgba(255,255,255,0.08)",
                                        border: "1px solid rgba(255,255,255,0.08)",
                                        backdropFilter: "blur(10px)",
                                    }}
                                >
                                    <Group gap="xs">
                                        <IconShieldLock size={20} color="#34d399" />
                                        <Text c="white" fw={600}>
                                            Secure & Reliable
                                        </Text>
                                    </Group>
                                </Paper>
                            </Group>
                        </Stack>
                    </Center>
                </Grid.Col>

                {/* RIGHT SIDE */}
                <Grid.Col
                    span={{ base: 12, md: 6 }}
                    style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        padding: 20,
                        position: "relative",
                        zIndex: 5,
                    }}
                >
                    <Paper
                        radius="30px"
                        p={{ base: "xl", sm: 40 }}
                        w="100%"
                        maw={520}
                        style={{
                            background: "rgba(255,255,255,0.08)",
                            border: "1px solid rgba(255,255,255,0.1)",
                            backdropFilter: "blur(30px)",
                            boxShadow: "0 10px 50px rgba(0,0,0,0.5)",
                        }}
                    >
                        {/* Mobile Logo */}
                        <Center hiddenFrom="md" mb="xl">
                            <Image src={CdrLogo} w={130} h={130} fit="contain" />
                        </Center>

                        {/* Heading */}
                        <Stack gap={4} mb="xl">
                            <Title
                                order={2}
                                style={{
                                    color: "white",
                                    fontWeight: 900,
                                    fontSize: "36px",
                                }}
                            >
                                {authMode === "login"
                                    ? "Welcome Back"
                                    : "Create Account"}
                            </Title>

                            <Text c="#cbd5e1" size="sm">
                                {authMode === "login"
                                    ? "Access your legal dashboard securely."
                                    : "Join CDR and manage court schedules professionally."}
                            </Text>
                        </Stack>

                        {/* FORM */}
                        <Stack gap="lg">
                            {authMode === "signup" && (
                                <TextInput
                                    radius="xl"
                                    size="lg"
                                    placeholder="Full Name"
                                    leftSection={<IconUser size={18} />}
                                    styles={{
                                        input: {
                                            background: "rgba(255,255,255,0.06)",
                                            border: "1px solid rgba(255,255,255,0.1)",
                                            color: "white",
                                            height: 58,
                                        },
                                    }}
                                    name="name"
                                    value={inputs.name}
                                    onChange={handleChange}
                                />
                            )}
                            {authMode === "signup" && (
                                <TextInput
                                    radius="xl"
                                    size="lg"
                                    placeholder="Enter your email"
                                    leftSection={<IconMail size={18} />}
                                    styles={{
                                        input: {
                                            background: "rgba(255,255,255,0.06)",
                                            border: "1px solid rgba(255,255,255,0.1)",
                                            color: "white",
                                            height: 58,
                                        },
                                    }}
                                    name="email"
                                    value={inputs.email}
                                    onChange={handleChange}
                                />
                            )}

                            <TextInput
                                radius="xl"
                                size="lg"
                                placeholder="Mobile Number"
                                leftSection={<IconPhone size={18} />}
                                styles={{
                                    input: {
                                        background: "rgba(255,255,255,0.06)",
                                        border: "1px solid rgba(255,255,255,0.1)",
                                        color: "white",
                                        height: 58,
                                    },
                                }}
                                name="phone"
                                value={inputs.phone}
                                onChange={handleChange}
                                maxlength={10}
                            />


                            <PasswordInput
                                radius="xl"
                                size="lg"
                                placeholder="Enter your password"
                                leftSection={<IconShieldLock size={18} />}
                                styles={{
                                    input: {
                                        background: "rgba(255,255,255,0.06)",
                                        border: "1px solid rgba(255,255,255,0.1)",
                                        color: "white",
                                        height: 58,
                                    },
                                }}
                                name="password"
                                value={inputs.password}
                                onChange={handleChange}
                            />

                            {authMode === "login" ? (
                                <Group justify="space-between">
                                    <Text size="sm" c="#cbd5e1">
                                        Secure Login Portal
                                    </Text>

                                    <Text
                                        size="sm"
                                        style={{
                                            color: "#60a5fa",
                                            cursor: "pointer",
                                            fontWeight: 600,
                                        }}
                                        onClick={OpenForgotModal}
                                    >
                                        Forgot Password?
                                    </Text>
                                </Group>
                            ) : (
                                <Text size="sm" c="#cbd5e1">
                                    By creating account you agree to Terms & Privacy Policy.
                                </Text>
                            )}

                            {/* BUTTON */}
                            <Button
                                radius="xl"
                                size="lg"
                                h={60}
                                variant="gradient"
                                gradient={{ from: "blue", to: "cyan", deg: 90 }}
                                style={{
                                    fontWeight: 800,
                                    fontSize: 16,
                                    boxShadow: "0 10px 30px rgba(59,130,246,0.45)",
                                }}
                                onClick={handleSubmit}
                                loading={loading}
                            >
                                {authMode === "login"
                                    ? "Login to Dashboard"
                                    : "Create Account"}

                            </Button>

                            {/* SWITCH */}
                            <Group justify="center" mt={4}>
                                <Text size="sm" c="#cbd5e1">
                                    {authMode === "login"
                                        ? "Don't have an account?"
                                        : "Already have an account?"}
                                </Text>

                                <Anchor
                                    component="button"
                                    type="button"
                                    onClick={() =>
                                        setAuthMode(
                                            authMode === "login" ? "signup" : "login"
                                        )
                                    }
                                    style={{
                                        color: "#60a5fa",
                                        fontWeight: 700,
                                        textDecoration: "none",
                                    }}
                                >
                                    {authMode === "login"
                                        ? "Create Account"
                                        : "Login"}
                                </Anchor>
                            </Group>
                        </Stack>

                        {/* Divider */}
                        <Divider
                            my="xl"
                            label="COURT DATE REMINDER"
                            labelPosition="center"
                            color="rgba(255,255,255,0.12)"
                        />

                        {/* PREMIUM FOOTER */}
                        <Group justify={isMobile ? 'center' : 'space-between'} align="center">
                            {/* Founder */}
                            <Stack gap={0} align={isMobile ? 'center' : 'flex-start'}>
                                <Text size="xs" c="#94a3b8">
                                    Founded By
                                </Text>

                                <Text
                                    fw={700}
                                    size="sm"
                                    style={{
                                        color: "#ffffff",
                                        letterSpacing: 0.5,
                                        cursor: "pointer",
                                    }}
                                    onClick={open}
                                >
                                    Adv. Abhiraj Yadav
                                </Text>
                            </Stack>

                            {/* Divider */}
                            <Box
                                style={{
                                    display: isMobile ? "none" : "block",
                                    width: 1,
                                    height: 35,
                                    background: "rgba(255,255,255,0.15)",
                                }}
                            />

                            {/* Developer */}
                            <Stack gap={0} align={isMobile ? 'center' : 'flex-end'}>
                                <Text size="xs" c="#94a3b8">
                                    Designed & Maintained
                                </Text>

                                <Text
                                    fw={700}
                                    size="sm"
                                    style={{
                                        color: "#60a5fa",
                                        letterSpacing: 0.5,
                                    }}
                                >
                                    GV InfoTech.org
                                </Text>
                            </Stack>
                        </Group>
                    </Paper>
                </Grid.Col>
            </Grid>
        </Box>
    );
}